import useI18n from '@/shared/hooks/usei18n'
import {
  CheckCircleIcon,
  CheckHalfDashedCircleIcon,
  DashedCircleIcon
} from '@/common/components/icons'
import ClockArrowIcon from '@/common/components/icons/ClockArrow/ClockArrow'
import RightArrow from '@/common/components/icons/RightArrow/RightArrow'
import cx from 'classnames'
import { Link, useParams } from 'react-router-dom'

export default function CbamReportingPeriodCard({
  periodId,
  status,
  label
}: {
  periodId: string
  status: string
  label: string
}) {
  const { t } = useI18n()
  const { declarantId } = useParams<{ declarantId: string }>()
  return (
    <Link to={`/cbam-reporting/${declarantId}/reports/${periodId}`}>
      <div
        className={cx(
          'bg-white min-w-72 transition-all duration-200 py-2 px-4 border flex items-center gap-3 shadow-drop hover:bg-blue-200 hover:border-blue-400 group/card'
        )}
      >
        {status === 'NOT_STARTED' && <DashedCircleIcon className="size-6 text-gray-400" />}
        {status === 'PAST_DEADLINE' && <ClockArrowIcon className="size-6 text-blue-400" />}
        {status === 'IN_PROGRESS' && (
          <CheckHalfDashedCircleIcon className="size-6 text-yellow-500" />
        )}

        {status === 'COMPLETED' && <CheckCircleIcon className="size-6 text-green-600" />}
        <div className="flex-1 flex flex-col gap-1">
          <h4 className="font-semibold">{label}</h4>
          <p className="text-sm text-gray-600">
            {t(`cbamReporting:cbamReportingPeriodCard.status.${status}`)}
          </p>
        </div>
        <span>
          <RightArrow className="size-full" />
        </span>
      </div>
    </Link>
  )
}
